import { Box, Typography } from '@material-ui/core'
import React from 'react'

import ButtonSubmit from '../common/ButtonSubmit'

const ButtonCheckout = ({ disabled, error, isContinue, onClick, submitting }) => (
  <>
    <ButtonSubmit
      color="primary"
      disabled={disabled}
      fullWidth
      onClick={onClick}
      submitting={submitting}
      variant="contained"
    >
      {isContinue ? 'Continue to checkout' : 'Place order'}
    </ButtonSubmit>
    <Box marginTop={2}>{error && <Typography color="error">{error}</Typography>}</Box>
  </>
)

export default ButtonCheckout
